<template>
  <transition name="notification" appear>
    <div
      class="notification"
      :class="[`notification-${notification.type}`]"
      v-if="notification.show"
    >
      <div class="notification-content">
        <i :class="iconClass"/>
        <span class="notification-message">{{ notification.message }}</span>
        <button class="notification-close" @click="closeNotification">
          <i class="fas fa-times"/>
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Notification',
  props: {
    notification: {
      type: Object,
      required: true,
      default: () => ({
        show: false,
        type: 'info',
        message: '',
        timeout: 5000
      })
    }
  },
  computed: {
    iconClass() {
      const icons = {
        success: 'fas fa-check-circle',
        error: 'fas fa-exclamation-circle',
        warning: 'fas fa-exclamation-triangle',
        info: 'fas fa-info-circle'
      }
      return icons[this.notification.type] || icons.info
    }
  },
  mounted() {
    // Auto-close notification after timeout
    if (this.notification.timeout > 0) {
      setTimeout(() => {
        this.closeNotification()
      }, this.notification.timeout)
    }
  },
  methods: {
    closeNotification() {
      this.$store.dispatch('clearNotification')
    }
  }
}
</script>

<style scoped>
.notification {
  position: fixed;
  top: 100px;
  right: 20px;
  z-index: 10001;
  max-width: 400px;
  min-width: 300px;
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-lg);
  background: var(--ds-white);
  border: 1px solid var(--ds-neutral-200);
  border-left: 4px solid var(--ds-neutral-300);
}

.notification-content {
  padding: 1rem 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.notification-message {
  flex: 1;
  font-weight: 500;
  font-size: 0.95rem;
  line-height: 1.4;
}

.notification-close {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 4px;
  transition: all 0.3s ease;
  opacity: 0.5;
  color: inherit;
}

.notification-close:hover {
  opacity: 1;
  background: var(--ds-neutral-100);
}

/* Notification Types */
.notification-success {
  background: var(--ds-white);
  border-color: var(--ds-neutral-200);
  border-left-color: var(--ds-accent);
  color: #065f46;
}

.notification-error {
  background: var(--ds-white);
  border-color: var(--ds-neutral-200);
  border-left-color: var(--ds-danger);
  color: #991b1b;
}

.notification-warning {
  background: var(--ds-white);
  border-color: var(--ds-neutral-200);
  border-left-color: var(--ds-warning);
  color: #92400e;
}

.notification-info {
  background: var(--ds-white);
  border-color: var(--ds-neutral-200);
  border-left-color: var(--ds-primary-500);
  color: #1e40af;
}

/* Transitions */
.notification-enter-active,
.notification-leave-active {
  transition: all 0.3s ease;
}

.notification-enter-from {
  opacity: 0;
  transform: translateX(100px);
}

.notification-leave-to {
  opacity: 0;
  transform: translateX(100px);
}

/* Mobile Responsiveness */
@media (max-width: 768px) {
  .notification {
    top: 80px;
    right: 10px;
    left: 10px;
    max-width: none;
    min-width: auto;
  }

  .notification-content {
    padding: 0.8rem 1rem;
  }

  .notification-message {
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  .notification {
    top: 70px;
    margin: 0 5px;
  }

  .notification-content {
    padding: 0.7rem 0.8rem;
    gap: 0.5rem;
  }

  .notification-message {
    font-size: 0.85rem;
  }
}
</style>
